module.exports = __webpack_public_path__ + "img/pålestikk_tredd_2.3156bf59.jpg";